const dayOfWeeks = [
  {
    key: 1,
    Title: "Monday",
  },
  {
    key: 2,
    Title: "Tuesday",
  },
  {
    key: 3,
    Title: "Wednesday",
  },
  {
    key: 4,
    Title: "Thursday",
  },
  {
    key: 5,
    Title: "Friday",
  },
  {
    key: 6,
    Title: "Saturday",
  },
  {
    key: 0,
    Title: "Sunday",
  },
];

export { dayOfWeeks };
